var usedIds;
var getUnusedId = INKIVE.Helpers.getUnusedId;

module.exports = function (svg) {
  usedIds = [];

  fixClipPathIds(svg);
  removeUnusedIds(svg);
  fixImagesIds(svg);

  return svg;
};

function fixImagesIds (svg) {
  $(svg).find('image').each(function (i, element) {
    element.getAttribute('id') || element.setAttribute('id', getUnusedId(svg));
  });
}

function fixClipPathIds (svg) {
  $(svg).find('[clip-path]').each(function (i, element) {
    var newId = getUnusedId(svg);
    var oldId = element.getAttribute('clip-path')
      .replace('url(', '')
      .replace(')', '')
      .replace(/"/g, '');

    usedIds.push(newId);
    element.setAttribute('clip-path', 'url(#' + newId + ')');

    $(svg).find(oldId).attr('id', newId);
  });
}

function removeUnusedIds (svg) {
  $(svg).find('[id]').each(function (i, element) {
    var id = element.getAttribute('id');
    _.contains(usedIds, id) || element.removeAttribute('id');
  });
}
